import {RxdbRepository} from "../../rxdb/rxdb.repository";
import {HttpClient} from "@angular/common/http";
import {StandaloneModeService} from "../../standalone-mode.service";
import {StandaloneQuoteManagerService} from "./standalone-quote-manager.service";
import {RemoteQuoteManagerService} from "./remote-quote-manager.service";
import {EppRouterService} from "../../router/epp-router.service";
import {QuoteServiceService} from "../../quote-service/quote-service.service";
import {Store} from "@ngrx/store";
import {TranslateService} from "@ngx-translate/core";
import {CustomerContractService} from "../../customer-contract/_services/customer-contract.service";
import {CmcProductManagerService} from "../../products/_services/cmc/cmc-product-manager.service";
import {RxdbQuoteRepository} from "../../rxdb/repositories/quotes/rxdb-quote.repository";
import {CoreState} from '../../store/reducers';
import {ProductManagerV2Service} from "../../products/_services/product-manager-v2.service";
import {OptionPricingItemMapper} from '../../models/quote/pricing-item/mapper/option-pricing-item.mapper';

export const quoteManagerServiceFactory = (standaloneModeService: StandaloneModeService, rxdbService: RxdbRepository, httpClient: HttpClient, eppRouterService: EppRouterService, quoteServiceService: QuoteServiceService, store: Store<CoreState>, translateService: TranslateService, customerContractService: CustomerContractService, productManagerV2Service: ProductManagerV2Service, cmcProductManagerService: CmcProductManagerService, optionPricingItemMapper: OptionPricingItemMapper) => {
    return standaloneModeService.isOffline() ? new StandaloneQuoteManagerService(
            new RxdbQuoteRepository(rxdbService),
            httpClient,
            eppRouterService,
            quoteServiceService,
            store,
            translateService,
            customerContractService,
            productManagerV2Service,
            cmcProductManagerService,
            optionPricingItemMapper)
        : new RemoteQuoteManagerService(
            httpClient,
            eppRouterService,
            quoteServiceService,
            store,
            translateService,
            customerContractService,
            productManagerV2Service,
            cmcProductManagerService,
            optionPricingItemMapper
        );
}
